export const newPointInitial = {
  pointName: "",
  pointValue: "",
  pointExpiry: 0,
};
export const handleChange = (event, setFunction, fields) => {
  const { value, name } = event.target;
  setFunction({ ...fields, [name]: value });
};
export const handleAddBox = (setFunction, value) => {
  setFunction(value);
};
export const newPointSubmit = (event, fields, setFunction) => {
  event.preventDefault();
  if (
    fields["pointName"] === "" ||
    fields["pointValue"] === "" ||
    fields["pointExpiry"] === 0
  ) {
    alert("Add values");
  } else {
    setFunction({
      details: fields,
    });
  }
};
export const deleteFunction = (
  setFunction,
  addBoxFunction,
  setNewPointFields
) => {
  setFunction({});
  addBoxFunction(false);
  setNewPointFields(newPointInitial);
};
